export const normalizeIxcApiUrl = value => {
  const rawValue = String(value || '').trim();
  if (!rawValue) return '';

  try {
    const url = new URL(rawValue);
    if (!['http:', 'https:'].includes(url.protocol) || !url.hostname) return '';

    return url.origin;
  } catch {
    return '';
  }
};

export const normalizeIxcApiKey = value => {
  const rawValue = String(value || '').trim();
  if (!rawValue || !rawValue.includes(':')) return rawValue;

  const bytes = new TextEncoder().encode(rawValue);
  const binaryValue = Array.from(bytes, byte => String.fromCharCode(byte)).join(
    ''
  );

  return window.btoa(binaryValue);
};

export const buildIxcFinancialTrustUnlockSettings = value => ({
  financial_trust_unlock: {
    enabled: Boolean(value?.enabled),
  },
});
